import {Injectable, Inject} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {PaginatedResult} from "./fetch-data/PaginatedResult";

@Injectable({
    providedIn: 'root'
})
export class LabelsService {

    _baseUrl: string;

    constructor(private _httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._baseUrl = baseUrl;
    }

    getLabelsForSupplier(
        view: number,
        labelCreated: boolean,
        filters?: LabelFilters,
        selectedEan?: number,
        pageSize: number = 100,
        pageNumber: number = 1
    ): Observable<PaginatedResult<ILabelRow>> {
        const requestUrl = this._baseUrl + 'api/label/GetForSupplierAsync';

        let params: { [key: string]: any } = {
            view: view,
            pageSize: pageSize,
            pageNumber: pageNumber,
            labelCreated: labelCreated
        };

        if (selectedEan) {
            params['forKwekerEan'] = selectedEan;
        }
        if (filters?.searchTerm) {
            params['searchTerm'] = filters.searchTerm;
        }
        if (filters?.potmaat) {
            params['potmaat'] = filters.potmaat;
        }
        if (filters?.leverdatum) {
            params['leverdatum'] = filters.leverdatum.toISOString();
        }
        if (filters?.levertijdstip) {
            params['levertijdstip'] = filters.levertijdstip;
        }
        if (filters?.kwekerartikelnr) {
            params['kwekerartikelnr'] = filters.kwekerartikelnr;
        }
        if (filters?.afmetingSticker) {
            params['afmetingSticker'] = filters.afmetingSticker;
        }

        return this._httpClient.get<PaginatedResult<ILabelRow>>(requestUrl, {params: params});
    }


    getLabelsForOrder(orderNr: string, selectedEan?: number): Observable<ILabelRow[]> {
        const requestUrl = this._baseUrl + 'api/label/GetLabelsForOrder';
        let param = {};
        param['orderNr'] = orderNr;
        if (selectedEan) {
            param['forKwekerEan'] = selectedEan;
        }
        return this._httpClient.get<ILabelRow[]>(requestUrl, {params: param});
    }


    downloadPDF(orderNrs: string[]): Observable<Blob | MediaSource> {
        const requestUrl = this._baseUrl + 'api/label/openasync';
        const param = {'orderNrs': orderNrs};

        return this._httpClient.get(requestUrl, {params: param, responseType: 'blob'});
    }

    markAsUnprinted(orderNrs: string[]): Observable<any> {
        const requestUrl = this._baseUrl + 'api/label/markAsUnprinted';

        return this._httpClient.post(requestUrl, orderNrs);
    }

    update(item: ILabelRow): Observable<any> {
        const requestUrl = this._baseUrl + 'api/label/' + item.id;

        return this._httpClient.put(requestUrl, item);
    }
}

export interface ISupplierLabels {
    items: ILabelRow[];
    totalCount: number;
}

export interface ILabelRow {
    id: number;
    labelId: number;
    orderNr: string;
    datumAangemaakt?: Date;
    labelIsCreated: boolean;
    ophaalMethode: string;
    ophaalDatum?: Date;
    potmaat?: number;
    barCode: string;
    leverDatumTijdstip?: Date;
    leverTijdstip: string;
    kwekerArtikelNr: string;
    debiteurNrs: string[];
    afmetingStickers: string[];
    klantArtikelOmschrijving: string;
    aantalFustLabels: number;
    aantalProductLabels: number;
    aanleverwijze: string;
    productStickerlocatie: string;
    fustStickerlocatie: string;
    opmerkingInstructie: string;
}

export class LabelFilters {
    searchTerm?: string;

    get searchTermIsEmpty(): boolean {
        return this.searchTerm == null || this.searchTerm == undefined || this.searchTerm == '';
    }

    kwekerartikelnr?: string;
    potmaat?: string;
    leverdatum?: Date;
    levertijdstip?: Date;
    afmetingSticker?: string;
}